Ext.ns('mx.comp');

mx.comp.LinkedComboBox = Ext.extend(Ext.form.ComboBox, {
    blankValue: null,
    advValues: null,
    valueField: 'id',
    displayField: 'name',
    forceSelection: true,
    editable: false,
    triggerAction: 'all',
    lazyInit: false,
    valueIsArray: false,

    initEvents: function() {
        mx.comp.LinkedComboBox.superclass.initEvents.apply(this, arguments);
        this.el.on('keydown', this.keySearch, this, true);
    },
    initList: function() {
        mx.comp.LinkedComboBox.superclass.initList.apply(this, arguments);
        if (this.list && this.pageSize) {
            this.pageTb.paramNames = this.paramNames;
        }
    },

    keySearch: function(e, target, options, donotinit) {
        if (this.editable) {
            return; // disable key search when editable
        }
        var thiz = this;

        if (this.store.getCount() == 0 && !donotinit) {
            var checkLetterOnLoad = function() {
                thiz.store.un('load', checkLetterOnLoad);
                thiz.keySearch(e, target, options, true);
            };
            this.store.on('load', checkLetterOnLoad);
            this.store.load();
        }

        var raw = e.getKey();
        var key = String.fromCharCode(raw);
        var startIndex = 0;

        if (!this.store.getCount()) {
            return;
        }

        // todo: support pgup, pgdown, home, end nav
        switch (raw) {
            case Ext.EventObject.HOME:
                e.stopEvent();
                this.selectFirst();
                return;

            case Ext.EventObject.END:
                e.stopEvent();
                this.selectLast();
                return;

            case Ext.EventObject.PAGEDOWN:
                this.selectNextPage();
                e.stopEvent();
                return;

            case Ext.EventObject.PAGEUP:
                this.selectPrevPage();
                e.stopEvent();
                return;
        }

        // skip special keys other than the shift key
        if ((e.hasModifier() && !e.shiftKey) || e.isNavKeyPress() || e.isSpecialKey()) {
            return;
        }
        this.search(this.displayField, key, 0);
    },

    search: function(field, value, startIndex) {
        field = field || this.displayField;
        var index = this.store.find.apply(this.store, arguments);
        if (index !== -1) {
            if (this.blankValue) {
                index++;
            }
            this.focusAndSelect(index);
        }
    },

    selectFirst: function() {
        this.focusAndSelect(this.store.data.first());
    },

    selectLast: function() {
        this.focusAndSelect(this.store.data.last());
    },

    onLoad: function() {
        if (!this.hasFocus) {
            return;
        }
        if (this.store.getCount() > 0) {
            this.expand();
            this.restrictHeight();
            if (this.lastQuery == this.allQuery) {
                if (this.editable) {
                    this.el.dom.select();
                }
                if (!this.selectByValue(this.value, true)) {
                    this.select(0, true);
                }
            } else {
                if (this.blankValue) {
                    this.select(1, true);
                } else {
                    this.selectNext();
                }
                if (
                    this.typeAhead &&
                    this.lastKey != Ext.EventObject.BACKSPACE &&
                    this.lastKey != Ext.EventObject.DELETE
                ) {
                    this.taTask.delay(this.typeAheadDelay);
                }
            }
        } else {
            this.onEmptyResults();
        }
        //this.el.focus();
    },

    selectPrevPage: function() {
        var index = Math.max(this.selectedIndex - 30, 0);
        this.focusAndSelect(this.store.getAt(index));
    },

    selectNextPage: function() {
        var index = Math.min(this.selectedIndex + 30, this.store.getCount() - 1);
        this.focusAndSelect(this.store.getAt(index));
    },

    focusAndSelect: function(record) {
        var index = typeof record === 'number' ? record : this.store.indexOf(record);
        this.select(index, this.isExpanded());
        this.onSelect(this.store.getAt(index), index, this.isExpanded());
    },

    initComponent: function() {
        mx.comp.LinkedComboBox.superclass.initComponent.call(this, arguments);
        this.addEvents('getparams', 'setvalue');
    },

    getValue: function() {
        return this.valueIsArray ? this.getValueArray() : this.getValueSingle();
    },

    setValue: function(v) {
        if (this.valueIsArray) {
            this.setValueArray(v);
        } else {
            this.setValueSingle(v);
        }
        this.validate.call(this);
    },
    getValueSingle: function() {
        if (this.getRawValue()) {
            var v = mx.comp.LinkedComboBox.superclass.getValue.call(this);
            return this.store ? this.findRecord(this.valueField, v) || v : v;
        }
        return null;
    },

    setValueSingle: function(v) {
        if (v instanceof Ext.data.Record) {
            this.valueNotFoundText = v && v.get(this.displayField);
        } else if (!v) {
            this.valueNotFoundText = '';
        }
        mx.comp.LinkedComboBox.superclass.setValue.apply(this, arguments);
        this.fireEvent('setvalue', v);
    },
    getValueArray: function() {
        var result = this.getValueSingle();
        return result ? [result] : new Array();
    },
    setValueArray: function(v) {
        if (v && typeof v.splice == 'function') {
            this.setValueSingle(v.length ? v[0] : '');
        } else {
            this.setValueSingle(v);
        }
    },
    // blankValue support {
    onRender: function() {
        this.tpl = '';
        if (this.blankValue) {
            var v = this.blankValue == ' ' ? '&nbsp;' : this.blankValue;
            this.tpl = '<div class="x-combo-list-item">' + v + '</div>';
        }
        if (this.advValues) {
            for (var i = 0; i < this.advValues.length; i++) {
                this.tpl += '<div class="x-combo-list-item">' + this.advValues[i].get(this.displayField) + '</div>';
            }
        }
        this.tpl +=
            '<tpl for="."><div class="x-combo-list-item" title="{' +
            this.displayField +
            '}">{' +
            this.displayField +
            '}</div></tpl>';

        mx.comp.LinkedComboBox.superclass.onRender.apply(this, arguments);
        if (this.blankValue) {
            var data = {};
            data[this.valueField] = null;
            data[this.displayField] = this.blankValue;
            this.blankRecord = new this.store.record(data);

            if (this.value) {
                this.setValue(this.value);
            } else {
                this.setValue(this.blankRecord);
            }
        }
    },
    onViewClick: function(doFocus) {
        var index = this.view.getSelectedIndexes()[0];
        var r = this.store.getAt(this.blankRecord ? index - 1 - (this.advValues ? this.advValues.length : 0) : index);

        if (!r && index == 0 && this.blankRecord) {
            r = this.blankRecord;
        }
        if (!r && index > 0 && this.advValues) {
            r = this.advValues[this.blankRecord ? index - 1 : index];
        }

        if (r) {
            this.onSelect(r, index);
        }
        if (doFocus !== false) {
            this.el.focus();
        }
    },
    onSelect: function(record, index, skipCollapse) {
        if (this.fireEvent('beforeselect', this, record, index) !== false) {
            this.setValue(record); // was ...(record.data[this.valueField || this.displayField]);
            if (!skipCollapse) {
                this.collapse();
            }
            this.lastSelectedIndex = index + 1;
            this.fireEvent('select', this, record, index);
        }
    },
    findRecord: function(prop, value) {
        return mx.comp.LinkedComboBox.superclass.findRecord.call(this, prop, value);
    },
    getParams: function() {
        var p = mx.comp.LinkedComboBox.superclass.getParams.call(this, arguments);
        this.fireEvent('getparams', p);
        return p;
    },
    selectByValue: function(v, scrollIntoView) {
        if (v !== undefined && v !== null) {
            var r = this.findRecord(this.valueField || this.displayField, v);
            if (r) {
                var index = this.store.indexOf(r);
                if (this.blankValue) {
                    index++;
                }
                this.select(index, scrollIntoView);
                return true;
            }
        }
        return false;
    },
    // blankValue support }
});

Ext.reg('mx-linkedcombo', mx.comp.LinkedComboBox);
